module.exports = __webpack_public_path__ + "static/media/fb.d852d3c3.png";